export enum COLOR {
    'BROWN' = '#A47E52',
    'DARKGREEN' = '#284B0F',
    'LIGHTGREEN' = '#8A9A58',
    'GOLD' = '#E6C300',
    'GREYWHITE' = '#f0f0f0',
    'WHITE' = '#ffffff'
}
